import React from 'react';
import './App.css';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import CardMedia from "@material-ui/core/CardMedia";
import {urlConfig} from './config'

export default class VideoInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            expandedIngestion: false,
            expandedLegal: false,
            expandedMeta: false,
            expandedThumbnail: false
        };
    }

    componentDidMount() {

    }

    handleExpandIngestion = () => {
        this.setState(state => ({expandedIngestion: !state.expandedIngestion}));
    };

    handleExpandLegal = () => {
        this.setState(state => ({expandedLegal: !state.expandedLegal}));
    };

    handleExpandMeta = () => {
        this.setState(state => ({expandedMeta: !state.expandedMeta}));
    };

    handleExpandThumbnail = () => {
        this.setState(state => ({expandedThumbnail: !state.expandedThumbnail}));
    };

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    render() {

        const {classes, theme} = this.props;

        const infoCardStyle = {
            minHeight: '230px'
        };

        const thumbnailCardStyle = {
            minHeight: '460px',
        };

        const captionStyle = {};

        const inlineStyle = {
                wordBreak:'normal'
        }

        return (


            <div>
                <Grid container spacing={0}>
                    <Grid item xs={8}>
                        <Grid container spacing={0}>

                            <Grid item xs={6}>

                                {this.props && this.props.clipData.entity &&
                                <Card style={infoCardStyle}>
                                    <CardContent>
                                        <Typography variant='subtitle1'>
                                            Ingestion
                                        </Typography>
                                        <List dense={true}>
                                            <ListItem>
                                                <ListItemText
                                                    primary={`CP : ${this.props.clipData.entity.data.contentPartner.name}`}/>
                                            </ListItem>

                                            <ListItem>
                                                <ListItemText
                                                    primary={`Channel : ${this.props.clipData.entity.data.channel.id}`}
                                                    secondary={`Name : ${this.props.clipData.entity.data.channel.name}`}/>
                                            </ListItem>


                                            {this.state.expandedIngestion &&
                                            <Button size="small"
                                                    onClick={this.handleExpandIngestion}
                                                    aria-expanded={this.state.expandedIngestion}
                                                    aria-label="Show more">Show Less
                                                <ExpandLessIcon/></Button>}
                                            {!this.state.expandedIngestion &&
                                            <Button size="small"
                                                    onClick={this.handleExpandIngestion}
                                                    aria-expanded={!this.state.expandedIngestion}
                                                    aria-label="Show more">Show More
                                                <ExpandMoreIcon/></Button>}

                                            <Collapse in={this.state.expandedIngestion} timeout="auto" unmountOnExit>
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`Ingestion Date : ${this.props.clipData.entity.data.ingestedDate}`}/>
                                                </ListItem>

                                                {this.props.clipData.entity.data.video &&
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`Duration : ${this.props.clipData.entity.data.video.duration}`}/>
                                                </ListItem>}

                                            </Collapse>

                                        </List>
                                    </CardContent>
                                </Card>}
                            </Grid>
                            <Grid item xs={6}>
                                {this.props && this.props.clipData.entity && this.props.clipData.entity.data
                                && this.props.clipData.entity.data.right && this.props.clipData.entity.data.right.profile &&
                                this.props.clipData.entity.data.right.profile.legal &&
                                <Card style={infoCardStyle}>
                                    <CardContent>
                                        <Typography variant='subtitle1'>
                                            Legal
                                        </Typography>
                                        <List dense={true}>
                                            <ListItem>
                                                <ListItemText
                                                    primary={`DRM : ${this.props.clipData.entity.data.right.profile.usage.drm}`}/>
                                            </ListItem>

                                            <ListItem>
                                                <ListItemText variant={'multiline'}
                                                              primary={<React.Fragment>
                                                                  <Typography style={inlineStyle}
                                                                              variant="body2"
                                                                              color="textPrimary"
                                                                  >
                                                                      Geo
                                                                      : {this.props.clipData.entity.data.right.profile.legal.geo}
                                                                  </Typography>

                                                    </React.Fragment>}
                                                    secondary={`Searchable : ${this.props.clipData.entity.data.right.profile.legal.viuIndexGeo}`}/>
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary={`Start Date : ${this.props.clipData.entity.data.right.profile.legal.startDate}`}/>
                                            </ListItem>
                                            {this.props.clipData.entity.data.right.profile.legal.endDate &&
                                            <ListItem>
                                                <ListItemText
                                                    primary={`End Date : ${this.props.clipData.entity.data.right.profile.legal.endDate}`}/>
                                            </ListItem>}


                                            {this.state.expandedLegal &&
                                            <Button size="small"
                                                    onClick={this.handleExpandLegal}
                                                    aria-expanded={this.state.expandedLegal}
                                                    aria-label="Show more">Show Less
                                                <ExpandLessIcon/></Button>}
                                            {!this.state.expandedLegal &&
                                            <Button size="small"
                                                    onClick={this.handleExpandLegal}
                                                    aria-expanded={!this.state.expandedLegal}
                                                    aria-label="Show more">Show More
                                                <ExpandMoreIcon/></Button>}

                                            <Collapse in={this.state.expandedLegal} timeout="auto" unmountOnExit>
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`Products : ${this.props.clipData.entity.data.right.profile.usage.products.reduce(function (accumulator, currentValue) {
                                                            if (accumulator) {
                                                                return accumulator + ',' + currentValue.name;
                                                            } else {
                                                                return currentValue.name;
                                                            }
                                                        }, 0)}`}/>
                                                </ListItem>
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`Profile Name : ${this.props.clipData.entity.data.right.profile.name}`}/>
                                                </ListItem>
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`Ads Allowed : ${this.props.clipData.entity.data.right.profile.legal.isAdsAllowed ? 'Yes' : 'No'}`}/>
                                                </ListItem>
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`Free/Paid : ${this.props.clipData.entity.data.right.profile.usage.freePaid}`}/>
                                                </ListItem>
                                            </Collapse>


                                        </List>
                                    </CardContent>
                                </Card>}
                            </Grid>
                        </Grid>
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                {this.props && this.props.clipData.entity &&
                                <Card style={infoCardStyle}>
                                    <CardContent>
                                        <Typography variant='subtitle1'>
                                            Meta
                                        </Typography>
                                        <List dense={true}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={3}>
                                                    <ListItem>
                                                        <ListItemText
                                                            primary={`Genre : ${this.props.clipData.entity.data.asset.meta.genre.name}`}/>
                                                    </ListItem>
                                                </Grid>
                                                {this.props.clipData.entity.data.asset.meta.subgenre &&
                                                <Grid item xs={3}>
                                                    <ListItem>
                                                        <ListItemText
                                                            primary={`Sub Genre : ${this.props.clipData.entity.data.asset.meta.subgenre.name}`}/>
                                                    </ListItem>
                                                </Grid>}
                                                <Grid item xs={6}>
                                                    <ListItem>
                                                        <ListItemText
                                                            primary={`Language : ${this.props.clipData.entity.data.asset.meta.language}`}/>
                                                    </ListItem>
                                                </Grid>
                                            </Grid>


                                            {this.props.clipData.entity.data.asset.meta.synopsis &&
                                            <ListItem>
                                                <ListItemText
                                                    primary={`Synopsis: ${this.props.clipData.entity.data.asset.meta.synopsis}`}/>
                                            </ListItem>}

                                            {this.state.expandedMeta &&
                                            <Button size="small"
                                                    onClick={this.handleExpandMeta}
                                                    aria-expanded={this.state.expandedMeta}
                                                    aria-label="Show more">Show Less
                                                <ExpandLessIcon/></Button>}
                                            {!this.state.expandedMeta &&
                                            <Button size="small"
                                                    onClick={this.handleExpandMeta}
                                                    aria-expanded={!this.state.expandedMeta}
                                                    aria-label="Show more">Show More
                                                <ExpandMoreIcon/></Button>}

                                            <Collapse in={this.state.expandedMeta} timeout="auto" unmountOnExit>

                                                <Grid container spacing={0}>
                                                    <Grid item xs={6}>
                                                        {this.props.clipData.entity.data.asset.meta.tvShow.episode.title &&
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={`Episode Title: ${this.props.clipData.entity.data.asset.meta.tvShow.episode.title}`}/>
                                                        </ListItem>}
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        {this.props.clipData.entity.data.asset.meta.tvShow.episode.title &&
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={`Episode Number: ${this.props.clipData.entity.data.asset.meta.tvShow.episode.number}`}/>
                                                        </ListItem>}
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={0}>
                                                    <Grid item xs={6}>
                                                        {this.props.clipData.entity.data.asset.meta.yearOfRelease &&
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={`Year of Release: ${this.props.clipData.entity.data.asset.meta.yearOfRelease}`}/>
                                                        </ListItem>}
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={`CP Logo Allowed : ${this.props.clipData.entity.data.asset.meta.isCPLogoDisplayAllowed ? 'Yes' : 'No'}`}/>
                                                        </ListItem>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={0}>
                                                    <Grid item xs={6}>
                                                        {this.props.clipData.entity.data.asset.meta.actors &&
                                                        <ListItem>

                                                            <ListItemText primary={`Actors:
                                                ${this.props.clipData.entity.data.asset.meta.actors.map(function (actor) {
                                                                return actor.name
                                                            })
                                                            }`}/>
                                                        </ListItem>}
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        {this.props.clipData.entity.data.asset.meta.actresses &&
                                                        <ListItem>

                                                            <ListItemText primary={`Actresses:
                                                ${this.props.clipData.entity.data.asset.meta.actresses.map(function (actress) {
                                                                return actress.name
                                                            })
                                                            }`}/>
                                                        </ListItem>}
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={0}>
                                                    <Grid item xs={6}>
                                                        {this.props.clipData.entity.data.asset.meta.directors &&
                                                        <ListItem>

                                                            <ListItemText primary={`Directors:
                                                ${this.props.clipData.entity.data.asset.meta.directors.map(function (director) {
                                                                return director.name
                                                            })
                                                            }`}/>
                                                        </ListItem>}
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        {this.props.clipData.entity.data.asset.meta.producers &&
                                                        <ListItem>

                                                            <ListItemText primary={`Producers:
                                                ${this.props.clipData.entity.data.asset.meta.producers.map(function (producer) {
                                                                return producer.name
                                                            })
                                                            }`}/>
                                                        </ListItem>}
                                                    </Grid>
                                                </Grid>

                                                {this.props.clipData.entity.data.asset.meta.tags &&
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`Tags: ${this.props.clipData.entity.data.asset.meta.tags}`}/>
                                                </ListItem>}

                                            </Collapse>
                                        </List>
                                    </CardContent>
                                </Card>}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={4}>
                        {this.props && this.props.clipData.entity &&
                        <Card style={thumbnailCardStyle}>
                            <CardContent>
                                <Typography variant='subtitle1' display="block">
                                    Thumbnails
                                </Typography>
                                <Grid container spacing={1}>

                                    {this.props.clipData.entity.data.asset.thumbnail.thumbnails.map(function (thumbnail, i) {

                                        let width = 800;
                                        let height = 600;

                                        let thumbnailWidth = 120;
                                        let thumbnailHeight = 90;

                                        if (thumbnail.aspectRatio === "4x3") {
                                            width = 800;
                                            height = 600;
                                            thumbnailWidth = 120;
                                            thumbnailHeight = 90;
                                        }

                                        if (thumbnail.aspectRatio === "16x9") {
                                            width = 800;
                                            height = 450;
                                            thumbnailWidth = 140;
                                            thumbnailHeight = 80;
                                        }

                                        if (thumbnail.aspectRatio === "27x40") {
                                            width = 810;
                                            height = 1200;
                                            thumbnailWidth = 112;
                                            thumbnailHeight = 166;
                                        }

                                        if (thumbnail.aspectRatio === "2x3") {
                                            width = 800;
                                            height = 1200;
                                            thumbnailWidth = 120;
                                            thumbnailHeight = 180;
                                        }

                                        if (thumbnail.aspectRatio === "1000x562") {
                                            width = 1000;
                                            height = 562;
                                            thumbnailWidth = 100;
                                            thumbnailHeight = 56;
                                        }

                                        if (thumbnail.aspectRatio === "1900x650") {
                                            width = 900;
                                            height = 300;
                                            thumbnailWidth = 120;
                                            thumbnailHeight = 40;
                                        }

                                        if (thumbnail.aspectRatio === "1x1.5") {
                                            width = 800;
                                            height = 1200;
                                            thumbnailWidth = 120;
                                            thumbnailHeight = 180;
                                        }

                                        let widthAndHeight = `${width}x${height}`;
                                        let thumbnailWidthAndHeight = `${thumbnailWidth * 2}x${thumbnailHeight * 2}`;

                                        const thumbnailContainerCardStyle = {
                                            width: thumbnailWidth,
                                            height: thumbnailHeight + 40,
                                            marginLeft: '12px',
                                            marginTop: '12px',
                                        };

                                        const thumbnailContainerCardStyleDefault = {
                                            width: thumbnailWidth,
                                            height: thumbnailHeight + 40,
                                            marginLeft: '12px',
                                            marginTop: '12px',
                                            border: 'solid',
                                            borderColor: 'lightgreen'
                                        };

                                        return <Grid item><Card key={i}
                                                                style={thumbnail.isDefault ? thumbnailContainerCardStyleDefault : thumbnailContainerCardStyle}>
                                            <CardMedia>
                                                <a href={`${urlConfig.thumbnailUrlBase}?cid=${thumbnail.tcid}&t=thumb${widthAndHeight}&v=${thumbnail.version}`}
                                                   target="_blank" rel="noopener noreferrer">
                                                    <img id={thumbnail.tcid} height={thumbnailHeight}
                                                         alt={`tcid=${thumbnail.tcid}`}
                                                         width={thumbnailWidth}
                                                         src={`${urlConfig.thumbnailUrlBase}?cid=${thumbnail.tcid}&t=thumb${thumbnailWidthAndHeight}&v=${thumbnail.version}`}>
                                                    </img>
                                                </a>
                                                <Typography variant={'caption'} display="block" style={captionStyle}>
                                                    {`${thumbnail.aspectRatio},${thumbnail.hasTitle ? 'With' : 'Without'} Title,v${thumbnail.version}`}
                                                </Typography>
                                            </CardMedia>


                                        </Card></Grid>;
                                    })}
                                </Grid>
                            </CardContent>
                        </Card>}
                    </Grid>


                </Grid>

            </div>
        )
    }
}